import { useRouteRef } from '@backstage/core-plugin-api';

import {
  AutocompleteEmptyState,
  ConfidenceAutocomplete,
  type ConfidenceAutocompleteProps,
} from '@spotify/confidence-core-react';
import { useEntitiesLazyQuery } from '@spotify/confidence-graphql';

import { entitiesRouteRef } from '../../routes';

type EntitySelectProps = Omit<
  ConfidenceAutocompleteProps,
  'value' | 'query' | 'onChange' | 'getOptionDisabled'
> & {
  value?: string | null;
  onChange: (newValue: string) => void;
  disabledOptions?: string[];
};

export const EntitySelect = ({
  value,
  label = 'Entity',
  onChange,
  disabledOptions,
  autoSelectSingle = true,
  ...autocompleteProps
}: EntitySelectProps) => {
  const entitiesRoute = useRouteRef(entitiesRouteRef);

  const getOptionDisabled = disabledOptions
    ? (option: { name: string } | null) =>
        !!option?.name && disabledOptions.includes(option.name)
    : undefined;

  return (
    <ConfidenceAutocomplete
      {...autocompleteProps}
      query={useEntitiesLazyQuery}
      autoSelectSingle={autoSelectSingle}
      label={label}
      data-testid="entity-select"
      value={value}
      onChange={(_e, entity) => onChange(entity || '')}
      getOptionDisabled={getOptionDisabled}
    >
      <AutocompleteEmptyState
        title="No entities"
        description={autocompleteProps.helperText}
        actionLabel="Create entity"
        actionLink={entitiesRoute?.()}
      />
    </ConfidenceAutocomplete>
  );
};
